module.exports = __webpack_public_path__ + "3-o2.jpg?5f3fa64d78e2454c85e93c29a620aa0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/3-o2.jpg
// module id = 653
// module chunks = 0